import React from 'react';
import { motion } from 'framer-motion';
import { Scissors, Crown, Clock, Instagram, Facebook } from 'lucide-react';
const WhatsAppIcon = () => <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-263">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" data-id="element-264" />
  </svg>;
const PHOTO_2 = 'https://cdn.magicpatterns.com/uploads/hD1oQ57ogVJ1pQErZip3Bq/quiero_que_le_borres_a_esta_im_Nano_Banana_2_05902.png';
const IMG_PHILOSOPHY = 'https://cdn.magicpatterns.com/uploads/cxj89ZPa318urzkTWW9dBL/dejame_esta_foto_mas_nitida_y__Nano_Banana_2_21117.png';
const PHOTO_5 = 'https://images.unsplash.com/photo-1599351431202-1e0f0137899a?w=1200';
export function Nosotros() {
  const values = [{
    icon: Scissors,
    text: 'Precisión en cada corte'
  }, {
    icon: Crown,
    text: 'Atención personalizada'
  }, {
    icon: Clock,
    text: 'Abiertos 7 días a la semana'
  }];
  return <section id="nosotros" className="py-20 bg-deepblack" data-id="element-265">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-266">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-267">
          {/* Left Column - Images */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="space-y-6" data-id="element-268">
            <div className="rounded-lg overflow-hidden border-2 border-gold shadow-gold-glow" data-id="element-269">
              <img src={PHOTO_2} alt="Santiago & Paola - Propietarios de El Rey Barba" className="w-full h-auto object-cover" data-id="element-270" />
            </div>
            <div className="rounded-lg overflow-hidden border-2 border-gold shadow-gold-glow bg-deepblack" data-id="element-271">
              <img src={IMG_PHILOSOPHY} alt="Filosofía: Detrás de un buen corte hay dedicación, paciencia y un buen barbero" className="w-full aspect-[16/10] object-cover object-center" data-id="element-272" />
            </div>
            <div className="flex items-center gap-6 justify-center" data-id="element-273">
              <a href="https://instagram.com/barberiaelreybarba" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gold hover:text-white transition-colors" data-id="element-274">
                <Instagram className="w-5 h-5" data-id="element-275" />
                <span className="text-sm font-medium" data-id="element-276">@barberiaelreybarba</span>
              </a>
              <a href="https://facebook.com/Barberiaelreybarba" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gold hover:text-white transition-colors" data-id="element-277">
                <Facebook className="w-5 h-5" data-id="element-278" />
                <span className="text-sm font-medium" data-id="element-279">@Barberiaelreybarba</span>
              </a>
            </div>
          </motion.div>

          {/* Right Column - Content */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="space-y-6" data-id="element-280">
            <div className="text-gold text-sm font-bold tracking-widest uppercase" data-id="element-281">
              QUIÉNES SOMOS
            </div>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-bone leading-tight" data-id="element-282">
              Más que una Barbería,
              <br data-id="element-283" />
              una Experiencia
            </h2>
            <p className="text-gold text-xl font-semibold" data-id="element-284">
              Liderado por Santiago & Paola
            </p>
            <p className="text-bone text-lg leading-relaxed" data-id="element-285">
              En El Rey Barba creemos que detrás de un buen corte hay
              dedicación, paciencia y un buen barbero. Somos un estudio de
              grooming en el corazón del Barrio Perdomo donde la rapidez y la
              atención al detalle son nuestra firma. Atendemos caballeros y
              niños con técnicas modernas y clásicas.
            </p>

            {/* Value Icons */}
            <div className="space-y-4 pt-4" data-id="element-286">
              {values.map((value, index) => {
              const Icon = value.icon;
              return <div key={index} className="flex items-center gap-4" data-id="element-287">
                    <div className="flex-shrink-0 w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center border border-gold" data-id="element-288">
                      <Icon className="w-6 h-6 text-gold" data-id="element-289" />
                    </div>
                    <p className="text-bone text-lg font-medium" data-id="element-290">
                      {value.text}
                    </p>
                  </div>;
            })}
            </div>

            {/* CTA Button */}
            <a href="https://wa.me/573028281216" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-gold text-deepblack px-8 py-4 rounded-full font-bold text-lg hover:bg-yellow-500 transition-all shadow-lg hover:shadow-gold-glow mt-6" data-id="element-291">
              <WhatsAppIcon data-id="element-292" />
              Escríbenos por WhatsApp
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}